module.exports = __webpack_public_path__ + "static/img/010.8bdf945.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/fish/yqs/010.png
// module id = frcJ
// module chunks = 0